export const updateWalletBalance = async (userId, topUpAmount) => {
  const payload = {
    userId: Number(userId),
    currentBalance: Number(topUpAmount), // 🔥 send only top-up amount
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}WalletAPI/UpdateWalletBalance`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
        },
        body: JSON.stringify(payload),
      }
    );

    const text = await response.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }

    return {
      ok: response.ok,
      raw: text,
      data,
    };
  } catch (error) {
    console.error("❌ Wallet API Error:", error);
    return {
      ok: false,
      error,
    };
  }
};
